<template>
    <div class="navHeader" id="headerH5">
        <div class="headerBox">
            <div class="nav-box">
                <div class="nav-top">
                    <div class="nav-left">
                        <a @click="goToPc()" class="icon-home"></a>
                    </div>
                    <!-- <div class="" style="height: 50px;width: 50px;position: absolute;right: 94px;top: 3.555555555555555px;">
                        <a id="jg" href=""> 
                          <span class="" style="font-size: 23px;line-height: 0.8rem;height: 50px;width: 50px;text-align: center;display: inline-block;">
                            <img src="http://www.test-5ibzy.com:28020/rec/5ibzy/default/images/mail.png" alt="" style="width: 50%;height: 50%;margin: auto;">
                          </span>
                        </a>
                    </div> -->
                    <div class="nav-user">
                        <span class="am-icon-user1" @click="h5login()">
                            <img src="https://www.5ibazhuayu.com.cn/rec/5ibzy/default/images/user.png" alt="">
                        </span>
                    </div>
                    <div class="nav-right">
                        <a href="javascript:void(0);" class="am-icon-more1" @click="showright()" style="display: inline-block;">
                            <img src="https://www.5ibazhuayu.com.cn/rec/5ibzy/default/images/more.png" alt="">
                        </a>
                    </div>
                </div>
                <div class="login-pop-box" v-show="showLogin">
                    <div class="login-box" v-show="!isLogin">
                        <a href="javascript:void(0);" class="sign-up-button" @click="jumpTo1('/register')">注册</a>
                        <a href="javascript:void(0);" class="login-button"  @click="jumpTo1('/login')">登录</a>
                    </div>
                    <div class="user-info-box" v-show="isLogin">
                        <a class="user-name">您好！ {{userAccount}}</a>
                        <a href="javascript:void(0)" class="logout-button" @click="logout()">退出</a>
                        <ul class="portal-box">
                            <li class="rightIcon" v-for="(value,key) in authorityList" :key="key" @click="jumpTo1('/'+key)" v-if="value.length>0">
                                <a>{{authorityMap[key]}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div :class="['nav-rightside-menu',{show:showrightFlag}]" v-show="showrightFlag">
                    <div class="dropdown-wrap">
                        <div class="dropdown">
                            <div class="dropdown-close-box" @click="showright()"></div>
                            <div class="dropdown-content">
                                <div class="channel-list clearfix">
                                    <div class="channel-item" v-for="item in navBarList" :key="item.id" v-if="checkShow(item.userType)">
                                        <div class="channel-item-title" @click="jumpToOuter(item.navBarLink,item.parentList.length>0||(item.cms2TitleContList&&item.cms2TitleContList.length>0),item.channelCode)"  :id="item.channelCode">
                                            <a :title="item.navBarName" class="channel-title" @click="jump(item.navBarLink)">
                                                {{item.navBarName}}
                                            </a>
                                            <span :class="['dbl-icon-base-arrow dbl-icon-base-arrow-down']" v-if="item.parentList.length>0||(item.cms2TitleContList&&item.cms2TitleContList.length>0)"></span>
                                        </div>
                                        <div class="sub-channel-box">
                                            <div class="sub-channel-list channel-list clearfix">
                                                <div class="sub-channel-item" v-for="element in item.cms2TitleContList" :key="element.id" v-if="item.cms2TitleContList&&item.cms2TitleContList.length>0&&checkShow(element.userType)" @click="jump(element.href)">
                                                    <div href="javascript:void(0);" class="sub-channel-title" >
                                                        <a>{{element.title}}</a>
                                                    </div>
                                                </div>
                                                <div class="sub-channel-item" v-for="element in item.parentList" :key="element.id" v-if="item.parentList.length>0&&checkShow(element.userType)">
                                                    <div href="javascript:void(0);" class="sub-channel-title" @click="jumpTo(element.navBarLink,element.cms2TitleContList&&element.cms2TitleContList.length>0,element.channelCode)" :id="element.channelCode">
                                                        <a @click="jump(element.navBarLink)">{{element.navBarName}}</a>
                                                        <span class="dbl-icon-base-arrow dbl-icon-base-arrow-down "  v-if="element.cms2TitleContList&&element.cms2TitleContList.length>0"></span>
                                                    </div>
                                                    <ul class="three-channel-list" v-if="element.cms2TitleContList&&element.cms2TitleContList.length>0">
                                                        <li v-for="ll in element.cms2TitleContList" :key="ll.href" @click="jump(ll.href)" v-if="checkShow(ll.userType)">
                                                            <a class="sub-channel-item-item" href="javascript:void(0);">{{ll.title}}</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast} from "mint-ui";
import url from "../config/url.js"
require("../status/js/jquery-1.8.2.min.js");
export default {
    data () {
        return {
            showLogin:false,
            isLogin:true,
            authorityMap:{
                account:"我的账户",
                agent:"代理业务",
                contract:"合作合同",   
                cooperation:"合作意向",   
                safe:"安全设置",   
            },
            authorityList:{},
            userAccount:"",
            showrightFlag:false,
            navBarList:[{
                channelCode:"index",
                id:21,
                navBarLink:"/",
                navBarName:"首页",
                navBarType:"index",
                parentList:[],
            },{
                channelCode:"product",
                id:22,
                navBarLink:"/html/product/index_1.html",
                navBarName:"找软件",
                navBarType:"index",
                parentList:[{
                    channelCode:"lsl",
                    navBarLink:"/product/index.htm",
                    navBarName:"非标类产品软件",
                    id:24,
                },{
                    channelCode:"fbl",
                    navBarLink:"/product/index.htm",
                    navBarName:"零售类产品软件",
                    id:25,
                }],
            }]
        }
    },
    props: {

    },
    methods: {
        jumpTo1(path,query){
            this.showLogin=false;
            this.$router.push({
                path,query
            });
        },
        showright() {
            this.showrightFlag=!this.showrightFlag;
        },

        showup(b) {
            if ($("#"+b).parent().find(".sub-channel-box").hasClass("show")) {
                $("#"+b).parent().find(" .sub-channel-box").removeClass("show");
                $("#"+b).parent().find(" .channel-item-title span.dbl-icon-base-arrow").removeClass("active");
            } else {
                $("#"+b).parent().find(" .channel-item-title span.dbl-icon-base-arrow").addClass("active");
                $("#"+b).parent().find(" .sub-channel-box").addClass("show");
            }
        },
        jumpToOuter(jumpUrl,flag,channelCode){
            !flag?this.jump(jumpUrl):this.showup(channelCode);
        },
        goToPc(){
            window.location.href =url.indexHtml
        },
        jumpTo(jumpUrl,flag,channelCode){
            !flag?this.jump(jumpUrl):this.showsecond(channelCode);
        },
        jump(jumpUrl){
            window.location.href =url.indexHtml+jumpUrl.trim();
        },
        showsecond(a) {
            if ($("#"+a).parent().find("ul.three-channel-list").hasClass("show")) {
                $("#"+a).find("span.dbl-icon-base-arrow").removeClass("active");
                $("#"+a).parent().find("ul.three-channel-list").removeClass("show");
            } else {
                $("#"+a).find("span.dbl-icon-base-arrow").addClass("active");
                $("#"+a).parent().find("ul.three-channel-list").addClass("show");
            }
    
        },
        checkShow(a=""){
            if(a==""){
                return true;
            }
            a=a.split(',');
            let b=new Set(this.userService.getModel().getData("userRoles")); 
            b.add("visitor");
            a=new Set(a);
            let intersectionSet = new Set([...a].filter(x => b.has(x)));
            return intersectionSet.size>0;
        },
        h5login() {
            this.showLogin=!this.showLogin;
        },

        logout() {
            this.userService.getModel().clear();
            window.location.href =url.jumpurl+"?type=logout" ;
        },
        getNavBar(){
            this.userService.getNavBar().then(
                ret=>{
                    this.navBarList=ret;
                },error=>{
                    Toast(error)
                }
            )
        }
    },
    created(){
        this.userAccount=this.userService.getModel().getModel().account
        this.authorityList=this.userService.getModel().getData("authorityList");
        this.getNavBar();
    }
}
</script>

<style lang="scss" scoped>

ul,li{
    padding:0;
    margin:0;
}
.navHeader {
    color:#333;
    .headerBox {
        position: relative;
        .nav-box{
            width: 100%;
            position: relative;
            background-color: #222;
            .nav-top {
                height: 1rem;
                position: relative;
                .nav-left {
                    height: 100%;
                    position: absolute;
                    padding-left: 0.3rem;
                    left: 0;
                    top: 0;
                    .icon-home {
                        display: block;
                        width: 1.65rem;
                        height: 0.4rem;
                        position: relative;
                        margin-top:0.3rem;
                        overflow: hidden;
                        background-image: url(https://www.5ibazhuayu.com.cn/rec/5ibzy/default/images/b-logo.png);
                        background-size: contain;
                        background-repeat: no-repeat;
                    }
                }
                .nav-user{
                    height: 1rem;
                    width: 1rem;
                    position: absolute;
                    right: 1rem;
                    top: 0;
                    .am-icon-user1 {
                        font-size: 0.46rem;
                        line-height: 1rem;
                        height:1rem;
                        width: 1rem;
                        text-align: center;
                        display: inline-block;
                        img{
                            width:50%;
                            height: 50%;
                            margin: auto
                        }
                    }
                }
                .nav-right {
                    height: 100%;
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 1rem;
                    height: 1rem;
                    .am-icon-more1 {
                        line-height: 1.2rem;
                        text-align: center;
                        width: 1rem;
                        height: 1rem;
                        display: inline-block;
                        img{
                            width:50%;
                            margin: auto;
                        }
                    }
                }
            }
        }
        .nav-rightside-menu {
            overflow: hidden;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 399;
            background-color: rgba(55,61,65,.4);
            .dropdown-wrap {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 100%;
                z-index: 399;
                opacity: 1;
                .dropdown {
                    overflow: hidden;
                    width: 100%;
                    height: 100%;
                    .dropdown-close-box {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                    }
                    .dropdown-content {
                        margin-left: 1.2rem;
                        padding-bottom: 0.7rem;
                        box-sizing: border-box;
                        height: 100%;
                        overflow: auto;
                        background-color: #2e2e2e;
                        display: block;
                        position: relative;
                        .channel-list {
                            width: 100%;
                            .channel-item {
                                float: left;
                                width: 100%;
                                box-sizing: border-box;
                                overflow: hidden;
                                position: relative;
                                border-bottom: 1px solid #444;
                                .channel-item-title {
                                    height: 0.8rem;
                                    line-height: 0.8rem;
                                    width: 100%;
                                    position: relative;
                                    padding: 0 0.32rem;
                                    box-sizing: border-box;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    .channel-title {
                                        font-size: 0.32rem;
                                        color: #fff;
                                        line-height: 0.8rem;
                                        height: 0.8rem;
                                        margin-right: 0.8rem;
                                    }
                                }
                                .dbl-icon-base-arrow {
                                    font-size: 0.28rem;
                                    position: absolute;
                                    line-height: 0.8rem;
                                    top: 0;
                                    width: 0.32rem;
                                    height: 0.16rem;
                                    right: 0.4rem;
                                    margin: 0.32rem 0;
                                    color: #fff;
                                    background: url(data:image/png;base64,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) no-repeat;
                                    background-size: 100% 100%;
                                }

                            }
                        }
                    }
                }
            }
        }
    }
}

.navHeader .headerBox  .nav-rightside-menu .dropdown-wrap .dropdown .dropdown-content .channel-list .channel-item  .active {
    background: url(data:image/png;base64,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) no-repeat;
    background-size: 100% 100%;
}
.navHeader .headerBox .show .dropdown-wrap {
    -webkit-animation: showMove .5s;
    animation: showMove .5s;
    left: 0;
}
.navHeader .headerBox  .nav-rightside-menu .dropdown-wrap .dropdown .dropdown-content .channel-list .channel-item .sub-channel-box .sub-channel-list.channel-grid {
    padding: 0.1rem;
}
.navHeader .headerBox .nav-rightside-menu .dropdown-wrap .dropdown .dropdown-content .channel-list .channel-item .sub-channel-box .sub-channel-list table {
    width: 100%;
}
.navHeader .headerBox  .nav-rightside-menu .dropdown-wrap .dropdown .dropdown-content .channel-list .channel-item .sub-channel-box .sub-channel-list table td {
    width: 50%;
    border-bottom: 1px solid #444;
    border-right: 1px solid #444;
}
.navHeader .headerBox  .nav-rightside-menu .dropdown-wrap .dropdown .dropdown-content .channel-list .channel-item .sub-channel-box {
    background-color: #3b3b3b;
}
.navHeader .headerBox  .nav-rightside-menu .dropdown-wrap .dropdown .dropdown-content .channel-list .channel-item .sub-channel-box .sub-channel-list table td a.sub-channel-item {
    padding: 0.12rem 0.4rem;
    line-height: 0.6rem;
    height: 1.44rem;
    border: none!important;
    width: 100%;
    position: relative;
    box-sizing: border-box;
    font-size: 0.28rem;
    color: #9b9ea0;
    display: block;
}
.navHeader .headerBox .nav-rightside-menu .dropdown-wrap .dropdown .dropdown-content .channel-list .channel-item .sub-channel-box .sub-channel-list table td.right-side {
    border-right: none;
}
.navHeader .headerBox  .nav-rightside-menu .dropdown-wrap .dropdown .dropdown-content .channel-list .channel-item .sub-channel-box .sub-channel-list table td {
    width: 50%;
    border-bottom: 1px solid #444;
    border-right: 1px solid #444;
}
.navHeader .headerBox  .nav-rightside-menu .dropdown-wrap .dropdown .dropdown-content .channel-list .channel-item .sub-channel-box .sub-channel-list {
    overflow: hidden;
}
.navHeader .headerBox  .nav-rightside-menu .dropdown-wrap .dropdown .dropdown-content .channel-list {
    width: 100%;
}
.navHeader .headerBox  .nav-rightside-menu .dropdown-wrap .dropdown .dropdown-content .channel-list .channel-item .sub-channel-box .sub-channel-list .sub-channel-item .sub-channel-title {
    font-size: 0.28rem;
    width: 100%;
    height: 0.8rem;
    line-height: 0.8rem;
    position: relative;
    padding: 0 0.6rem;
    box-sizing: border-box;
    color: #9b9ea0;
    display: block;
    border-bottom: 1px solid #444;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.navHeader .headerBox  .nav-rightside-menu .dropdown-wrap .dropdown .dropdown-content .channel-list .channel-item .sub-channel-box .sub-channel-list .sub-channel-item .sub-channel-title a{
    color: #9b9ea0;
}

.navHeader .headerBox .nav-rightside-menu .dropdown-wrap .dropdown .dropdown-content .channel-list .channel-item .sub-channel-box .sub-channel-list .sub-channel-item .three-channel-list.show {
    display: block;
    border-bottom: 1px solid #444;
}
.navHeader .headerBox .nav-rightside-menu .dropdown-wrap .dropdown .dropdown-content .channel-list .channel-item .sub-channel-box .sub-channel-list .sub-channel-item .three-channel-list{
    display: none;
    border-bottom: 1px solid #444
}
.navHeader .headerBox .sub-channel-item-item {
    height: 0.8rem;
    width: 100%;
    line-height: 0.8rem;
    padding: 0 1rem;
    display: block;
    color: #9b9ea0;
    font-size: 0.28rem;
    border-bottom: 1px solid #444;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.navHeader .headerBox .nav-rightside-menu .dropdown-wrap .dropdown .dropdown-content .channel-list .channel-item .sub-channel-box{
    display: none;
}
.navHeader .headerBox .nav-rightside-menu .dropdown-wrap .dropdown .dropdown-content .channel-list .channel-item .sub-channel-box .sub-channel-list table td.bottom-side {
    border-bottom: none;
}
.navHeader .headerBox .hide {
    transition: 1s;
    left: 100%;
}
.navHeader .headerBox  .hide .dropdown-wrap {
    transition: 1s;
    left: 100%;
}
.nav-rightside-menu.show {
    -webkit-animation: showFade .5s;
    animation: showFade .5s;
    opacity: 1;
}
.navHeader .headerBox .nav-box .login-pop-box {
    z-index: 299;
    background-color: #383838;
    width: 100%;
}
.navHeader .headerBox .nav-box .login-pop-box .login-box {
    height: 1.2rem;
    width:100%;
    padding: 0.2rem;
    box-sizing: border-box;
    left: 0;
}
.navHeader .headerBox .login-pop-box .login-box .sign-up-button {
    width: 45%;
    height: 0.7rem;
    line-height: 0.7rem;
    display: block;
    float: left;
    text-align: center;
    font-size: 0.32rem;
    color: #fff;
    background-color: #00c1de;
}
.navHeader .headerBox  .login-pop-box .login-box .login-button {
    float: right;
    color: #00c1de;
    border: 1px solid #00c1de;
    box-sizing: border-box;
    text-decoration: none;
    width: 45%;
    height: 0.7rem;
    line-height: 0.7rem;
    font-size: 0.32rem;
    text-align: center;
    display: inline-block;
}
.navHeader .headerBox  .login-pop-box .user-info-box {
    color: #fff;
    line-height: 0.8rem;
    padding: 0 0.32rem;
    font-size: 0.32rem;
    .user-name{
        color:#00b7d3;
        padding-left: 0.28rem;
    }
    .portal-box{
        list-style: none;
        margin: 0;
        padding: 0;
        li{
            margin: 0;
            padding: 0;
            height: 0.8rem;
            line-height: 0.8rem;
            border-top: 1px solid #73777A;
            a{
                display: block;
                padding: 0 0.13rem;
                font-size: 0.32rem;
                color: #FFF;
            }
        }
    }
}
.navHeader .headerBox  .login-pop-box .user-info-box .logout-button {
    margin-left: 0.5rem;
    color: #00b7d3;
}
.show{
    display: block !important;
}

</style>





// WEBPACK FOOTER //
// src/components/header.vue